<template>
  <nav v-if="!thePublic">
    <v-app-bar dark color="primary"
      :src="require('@/assets/media/angryimg.png')"
      height="100"
      flat
    >
      <v-app-bar-nav-icon
        v-if="subscription > 0"
        @click="drawer = true"
      ></v-app-bar-nav-icon>

      <v-toolbar-title router to="/">
        <v-img :src="require('@/assets/media/mi-sos-brand.png')"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="ma-4" v-if="loggedIn">
        <span class="text-body-2 text-sm-h6 text-md-h5">{{ account }}</span><br><div class="text-caption">Profile: {{ accProfile }}</div>
      </v-toolbar-title>
      <!-- Logout -->
      <v-menu
            bottom
            left
            v-if="loggedIn"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list nav dense>
              <v-list-item color="primary" dense>
                <v-list-item-title @click="logout" class="white-text">Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
      <!-- Logout -->
      <v-btn
        v-for="authLink in authLinks"
        :key="authLink.name"
        text
        class="white--text font-weight-bold mx-2"
        color="white"
        router
        :href="authLink.url"
        v-text="authLink.name"
      ></v-btn>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute temporary v-if="subs > 0">
      <v-list nav dense>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item
            v-for="sideItem in sideItems"
            :key="sideItem.name"
            router
            :to="sideItem.url"
          >
            <v-list-item-icon>
              <v-icon>{{ sideItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ sideItem.title }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>

        <div class="pa-2">
          <v-btn block>Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("userauth", {
      loggedIn: "gLoggedIn"
    }),
    ...mapGetters("user", {
      account: "gAccountName",
      subs: "gProfileSubscription",
      accProfile: "gProfile"
    })
  },
  watch: {
    loggedIn: function() {
      this.refreshMenu();
      return 1;
    },
    subs() {
      this.subscription = this.subs;
    },
    accProfile() {
      this.profile = this.accProfile;
    }
  },
  created() {
    if (this.$route.name == 'Public' || this.$route.name == 'oldPublic') {
      this.thePublic = true;
    } else {
      this.thePublic = false;
    }
    this.refreshMenu();
  },
  methods: {
    logout() {
      this.$router.push({ name: 'Logout'})
    },
    refreshMenu() {
      
      this.subscription = this.subs;
      if (this.loggedIn) {
        this.authLinks = [];
      } else if (!this.loggedIn) {
        this.authLinks = [
          {
            name: "Login",
            url: "https://account.mi-sos.org/login"
          },
          {
            name: "Register",
            url: "https://www.mi-sos.org/create-account"
          }
        ];
      }
    }
  },
  data: () => ({
    thePublic: false,
    drawer: false,
    authLinks: [],
    subscription: 0,
    profile: '',
    sideItems: [
      {
        title: "Site Home",
        url: "/profile_home",
        icon: "mdi-home"
      },
      {
        title: "Account Profiles",
        url: "/profiles",
        icon: "mdi-folder-account"
      },
      {
        title: "Personal Information",
        url: "/personal",
        icon: "mdi-account-box"
      },
      {
        title: "Emergency Contacts",
        url: "/ice_contacts",
        icon: "mdi-account-multiple"
      },
      {
        title: "GP Details",
        url: "/gp",
        icon: "mdi-doctor"
      },
      {
        title: "Conditions",
        url: "/conditions",
        icon: "mdi-hospital-box"
      },
      {
        title: "Medications",
        url: "/medications",
        icon: "mdi-bottle-tonic-plus"
        //icon: "mdi-bottle-tonic-plus"
      },
      {
        title: "Vaccinations",
        url: "/vaccinations",
        icon: "mdi-needle"
      },
      {
        title: "Allergies",
        url: "/allergies",
        icon: "mdi-bee-flower"
      },
      {
        title: "Devices",
        url: "/devices",
        icon: "mdi-robot-industrial"
      },
      {
        title: "Files",
        url: "/files",
        icon: "mdi-file-image-outline"
      },
      {
        title: "QR Code",
        url: "/qrcode",
        icon: "mdi-qrcode-scan"
      },
      {
        title: "Logout",
        url: "/logout",
        icon: "mdi-logout"
      }
    ]
  })
};
</script>

<style></style>
